import { render } from "./LinkCustomerShippingAddressesToSalesRepModal.html?vue&type=template&id=67dc661c&scoped=true"
import script from "./LinkCustomerShippingAddressesToSalesRepModal.js?vue&type=script&lang=js"
export * from "./LinkCustomerShippingAddressesToSalesRepModal.js?vue&type=script&lang=js"

import "./LinkCustomerShippingAddressesToSalesRepModal.css?vue&type=style&index=0&id=67dc661c&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67dc661c"]])

export default __exports__